import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import DefaultRedirectsPage from './Pages/DefaultRedirectsPage';
import WizardPage from './Pages/WizardPage';

const CustomDomainRouter = () => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/wizard`}>
                <WizardPage />
            </Route>
            <Route path={`${path}/:cobrandedUrlId/wizard`}>
                <WizardPage />
            </Route>
            <Route default>
                <DefaultRedirectsPage />
            </Route>
        </Switch>
    );
};

export default CustomDomainRouter;
